import { Check } from "lucide-react";

const AnswerCard = ({ name, option, multi, checked, onChange }) => (
  <label className="block cursor-pointer">
    <input type={multi ? "checkbox" : "radio"} name={name} value={option.value} checked={checked} onChange={onChange} className="peer sr-only" data-testid={`journey-option-${name}-${option.value}`} />
    <span className={`flex items-center gap-4 rounded-2xl border-2 px-5 py-4 min-h-[64px] text-[1.02rem] font-medium transition-colors duration-150 peer-focus-visible:outline peer-focus-visible:outline-[3px] peer-focus-visible:outline-offset-2 peer-focus-visible:outline-teal ${checked ? "border-teal bg-teal-light text-ink" : "border-cream-deep bg-white/80 hover:border-ink/30"}`}>
      <span className={`flex h-6 w-6 shrink-0 items-center justify-center border-2 ${multi ? "rounded-md" : "rounded-full"} ${checked ? "border-teal bg-teal" : "border-ink/30 bg-white"}`} aria-hidden="true">
        {checked && <Check className="h-4 w-4 text-cream" strokeWidth={3} />}
      </span>
      {option.label}
    </span>
  </label>
);

export const QuestionStep = ({ q, value, onChange, headingRef }) => {
  const multi = q.type === "multi";
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <fieldset data-testid={`journey-question-${q.id}`}>
      <legend className="w-full">
        <h1 ref={headingRef} tabIndex={-1} className="focus-visible:outline-none text-3xl sm:text-4xl leading-tight">{q.question}</h1>
        {q.hint && <span className="mt-3 block text-ink-soft">{q.hint}</span>}
      </legend>
      <div className="mt-6 grid gap-3">
        {q.options.map((o) => (
          <AnswerCard key={o.value} name={q.id} option={o} multi={multi}
            checked={multi ? value.includes(o.value) : value === o.value}
            onChange={() => (multi ? toggle(o.value) : onChange(o.value))} />
        ))}
      </div>
    </fieldset>
  );
};
